import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 2,
        px: 3,
      }}
      className="animate__animated animate__fadeIn animate__delay-1=05s"
    >
      <Typography variant="body2" sx={{ mr: 2 }}>
        &copy; {new Date().getFullYear()} The Coca-Cola Company. All rights reserved.
      </Typography>
    </Box>
  );
};

export { Footer };
